module.exports = __webpack_public_path__ + "static/endgame-fde58a4aa07cbe567188e8d620f35319.jpg";